const matchStatusTransformer = status => {
  const expectedData = {
    W: 'primary',
    L: 'error',
    D: 'light'
  }

  return expectedData[status]
}

const reverseFormeArray = formeArray => {
  const reversedArray =
    formeArray &&
    formeArray
      .split('')
      .reverse()
      .join('')

  return reversedArray
}

export { matchStatusTransformer, reverseFormeArray }
